import { useCallback, useEffect, useState } from "react";
import fetchStatus from "src/utils/api/fetch-status";

const useApi = (requestMethod, condition = true, options = {}) => {
    const [state, setState] = useState({
        status: fetchStatus.PENDING,
        data: null,
        errorCode: null,
    });

    const fetchFromApi = useCallback(async () => {
        try {
            const response = await requestMethod(options);
            setState({
                status: fetchStatus.SUCCESS,
                data: response,
                errorCode: null,
                fetchedAt: new Date().valueOf(),
            });
        } catch (e) {
            setState({
                status: fetchStatus.ERROR,
                data: null,
                errorCode: e.status,
                error: e.message,
                fetchedAt: new Date().valueOf(),
            });
        }
    }, [options && JSON.stringify(options)]);

    useEffect(() => {
        if (condition) {
            fetchFromApi();
        }
    }, [condition, options && JSON.stringify(options)]);

    const refetch = (noSkeletons) => {
        if (noSkeletons) return fetchFromApi();
        setState({
            ...state,
            status: fetchStatus.REFETCHING,
        });
        return fetchFromApi();
    };

    return {
        ...state,
        refetch,
    };
};

export default useApi;
